export const colors = {
    white: '#fff',
    black: '#1A1A1A',
    blackLowContrast: 'rgba(0, 0, 0, 0.6)',
    main: '#000',
    pinkAmour: '#f6e6f2',
    gray: '#858585',
    darkGray: '#575757',
    silver: '#ccc',
    border: '#ccc',
    silverChalice: '#aeaeae',
    grayAlto: '#d1d1d1',
    grayAltoDark: '#cecece',
    grayAlabaster: '#f7f7f7',
    grayAthens: '#e6e8ed',
    grayCultured: '#F4F4F4',
    greenPersian: '#36b587',
    secondary: '#36b587',
    greenNasty: '#6eb243',
    berry: '#a51780',
    mintCream: '#E7FAF3',
    palePurple: '#FFE4FA',
    paypoGreen400: '#54DBA7',
    paypoGreen500: '#2CD091',
    paypoGreen600: '#22A271',
    paypoDarkGreen: '#187350',
    paypoLigthtGrey: '#E6E6E6',
    fuchsia500: '#A70584',
    yellow500: '#FAC42F',
};

export const breakpoints = {
    small: '360px',
    medium: '768px',
    big: '1024px',
    large: '1140px',
};
